import React, { ReactElement } from 'react';

import '@philips-internal/oswald-ui-components';
import { Foundation } from '@philips-internal/oswald-ui-foundation';
import { createRoot } from 'react-dom/client';

import { bootstrap } from './configuration';

import '@philips-internal/customer-portal-components';
import './controllers';

function RootApp(): ReactElement {
  return (
    <Foundation
      bootstrap={bootstrap}
      root={{
        fragmentName: 'root',
      }}
    />
  );
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<RootApp />);
}
